import React, { useState, useRef } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../Event/event";

const MultipleOrNotGame = () => {
  const [selectedBase, setSelectedBase] = useState(null);
  const [currentNumber, setCurrentNumber] = useState(null);
  const [feedback, setFeedback] = useState('');
  const [buttonsEnabled, setButtonsEnabled] = useState(false);

  const correctSound = useRef(new Audio('https://actions.google.com/sounds/v1/cartoon/clang_and_wobble.ogg'));
  const wrongSound = useRef(new Audio('https://actions.google.com/sounds/v1/cartoon/wood_plank_flicks.ogg'));

  const getRandomNumber = () => Math.floor(Math.random() * 100) + 1;

  const isMultiple = (num, base) => num % base === 0;

  const showNextNumber = () => {
    setCurrentNumber(getRandomNumber());
    setFeedback('');
    setButtonsEnabled(true);
  };

  const handleAnswer = (answer) => {
    if (selectedBase === null) return;
    const correct = isMultiple(currentNumber, selectedBase);

    if (answer === correct) {
      setFeedback('✅ Correct!');
      correctSound.current.currentTime = 0;
      correctSound.current.play();
      setButtonsEnabled(false); // prevent double click

      setTimeout(() => {
        showNextNumber();
      }, 800);

      ConstructorEventUpdateSQLStatus()
        .then((response) => {
          console.log("Event completed", response);
        })
        .catch((err) => console.error("Error updating event:", err));
    } else {
      setFeedback('❌ Try again!');
      wrongSound.current.currentTime = 0;
      wrongSound.current.play();
      setButtonsEnabled(false);
      setTimeout(() => {
        setFeedback('');
        setButtonsEnabled(true); // Re-enable buttons after short pause
      }, 800);
    }
  };

  const handleSelectChange = (e) => {
    const value = parseInt(e.target.value);
    setSelectedBase(value);
    showNextNumber();
  };

  const styles = {
    body: {
      fontFamily: "'Comic Sans MS', cursive, sans-serif",
      background: '#f0f9ff',
      textAlign: 'center',
      padding: '5vw',
      color: '#01579b',
      minHeight: '100vh',
    },
    h1: {
      fontSize: 'clamp(2rem, 5vw, 3rem)',
      marginBottom: '0.3em',
    },
    controls: {
      marginBottom: '20px',
    },
    select: {
      fontSize: '1.2rem',
      padding: '10px',
      borderRadius: '10px',
      border: '2px solid #0277bd',
    },
    numberDisplay: {
      fontSize: 'clamp(3rem, 8vw, 5rem)',
      fontWeight: 'bold',
      color: '#004d40',
      margin: '30px 0',
    },
    question: {
      fontSize: 'clamp(1.4rem, 4vw, 2rem)',
      marginBottom: '20px',
    },
    buttonContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: '30px',
      marginBottom: '30px',
    },
    button: {
      padding: '1rem 2.5rem',
      fontSize: 'clamp(1.2rem, 4vw, 1.8rem)',
      border: 'none',
      borderRadius: '12px',
      cursor: 'pointer',
      boxShadow: '0 6px 12px rgba(0,0,0,0.1)',
      userSelect: 'none',
      transition: 'transform 0.2s',
    },
    yesBtn: {
      backgroundColor: '#43a047',
      color: 'white',
    },
    noBtn: {
      backgroundColor: '#e53935',
      color: 'white',
    },
    feedback: {
      fontSize: 'clamp(1.3rem, 4vw, 1.8rem)',
      height: '40px',
      marginBottom: '20px',
    },
  };

  return (
    <div style={styles.body}>
      <h1 style={styles.h1}>Multiple or Not?</h1>

      <div style={styles.controls}>
        <label htmlFor="baseSelect">Select a number: </label>
        <select id="baseSelect" style={styles.select} onChange={handleSelectChange} defaultValue="">
          <option value="">--Choose--</option>
          {[...Array(9)].map((_, i) => (
            <option key={i + 2} value={i + 2}>{i + 2}</option>
          ))}
        </select>
      </div>

      <div style={styles.question}>Is this a multiple of your selected number?</div>
      <div style={styles.numberDisplay}>{currentNumber ?? '❓'}</div>

      <div style={styles.buttonContainer}>
        <button
          style={{ ...styles.button, ...styles.yesBtn }}
          onClick={() => handleAnswer(true)}
          disabled={!buttonsEnabled}
        >
          YES
        </button>
        <button
          style={{ ...styles.button, ...styles.noBtn }}
          onClick={() => handleAnswer(false)}
          disabled={!buttonsEnabled}
        >
          NO
        </button>
      </div>

      <div style={{ ...styles.feedback, color: feedback.includes('✅') ? '#2e7d32' : '#c62828' }}>
        {feedback}
      </div>
    </div>
  );
};

export default MultipleOrNotGame;
